import { render, staticRenderFns } from "./RateReviewPost.vue?vue&type=template&id=1fc7fcf5"
import script from "./RateReviewPost.vue?vue&type=script&lang=js"
export * from "./RateReviewPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports